<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="" v-show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
          <label class="txt-right required">Công ty</label>
          <DropdownScrollable placeholder="Chọn công ty" cusClass="text-box m-0" width="100%" :limit="company_obj.limit" :loading="company_obj.loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="company_obj.items" :total="company_obj.total" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'" @scroll="emitEvent"/>
          <input class="input_tmp_validator" id="company" />
        </div>
        <div v-if="mode=='edit'" class="mt-3">
          <label class="txt-right required">Phiếu đánh giá</label>
          <InputText
            v-model="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            maxlength="255"
          />
          <input class="input_tmp_validator" id="name" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Khu vực</label>
          <DropdownScrollable
            placeholder="Chọn"
            :showClear="true"
            cusClass="text-box m-0"
            width="100%"
            :multiple="false"
            :limit="areas_obj.limit"
            :loading="areas_obj.loading"
            v-model="areas"
            :options="areas_obj.items"
            :total="areas_obj.total"
            onlyClick
            @keyup="emitEventAreas"
            @scroll="emitEventAreas"
            @offset="changeOffsetAreas"
          />
          <input class="input_tmp_validator" id="areas" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Bộ phận</label>
          <DropdownScrollable
            :disabled="mode=='edit'"
            placeholder="Chọn"
            :showClear="true"
            cusClass="text-box m-0"
            width="100%"
            :multiple="false"
            :limit="department_obj.limit"
            :loading="department_obj.loading"
            v-model="department"
            :options="department_obj.items"
            :total="department_obj.total"
            onlyClick
            @keyup="emitEventDepartment"
            @scroll="emitEventDepartment"
            @offset="changeOffsetDepartment"
          />
          <input class="input_tmp_validator" id="department" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Công việc</label>
          <DropdownScrollable
            :disabled="mode=='edit'"
            placeholder="Chọn"
            :showClear="true"
            cusClass="text-box m-0"
            width="100%"
            :multiple="false"
            :limit="work_obj.limit"
            :loading="work_obj.loading"
            v-model="work"
            :options="work_obj.items"
            :total="work_obj.total"
            onlyClick
            @keyup="emitEventWork"
            @scroll="emitEventWork"
            @offset="changeOffsetWork"
          />
          <input class="input_tmp_validator" id="work" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Hạn chót</label>
          <Calendar id="icon" class="text-box" v-model="expiration_date" dateFormat="dd/mm/yy" :showIcon="true" />
          <input class="input_tmp_validator" id="expiration_date" />
        </div>
        <div class="mt-3">
          <label class="txt-right">THÔNG TIN NHÂN SỰ</label>
        </div>
        <div class="mt-3">
          <label class="txt-right required">Người approve</label>
          <DropdownScrollable
            placeholder="Chọn"
            :showClear="true"
            cusClass="text-box m-0"
            width="100%"
            :multiple="false"
            :limit="approve_obj.limit"
            :loading="approve_obj.loading"
            v-model="approve"
            :options="approve_obj.items"
            :total="approve_obj.total"
            onlyClick
            @keyup="emitEventApprove"
            @scroll="emitEventApprove"
            @offset="changeOffsetApprove"
          />
          <input class="input_tmp_validator" id="approve" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Người review</label>
          <DropdownScrollable
            placeholder="Chọn"
            :showClear="true"
            cusClass="text-box m-0"
            width="100%"
            :multiple="false"
            :limit="review_obj.limit"
            :loading="review_obj.loading"
            v-model="review"
            :options="review_obj.items"
            :total="review_obj.total"
            onlyClick
            @keyup="emitEventReview"
            @scroll="emitEventReview"
            @offset="changeOffsetReview"
          />
          <input class="input_tmp_validator" id="review" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Người thực hiện</label>
          <DropdownScrollable
            placeholder="Chọn"
            :showClear="true"
            cusClass="text-box m-0"
            width="100%"
            :multiple="false"
            :limit="implementer_obj.limit"
            :loading="implementer_obj.loading"
            v-model="implementer"
            :options="implementer_obj.items"
            :total="implementer_obj.total"
            onlyClick
            @keyup="emitEventImplementer"
            @scroll="emitEventImplementer"
            @offset="changeOffsetImplementer"
          />
          <input class="input_tmp_validator" id="implementer" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Người tham gia</label>
          <DropdownScrollable
            placeholder="Chọn"
            :showClear="false"
            cusClass="text-box m-0"
            width="100%"
            :multiple="false"
            :limit="participant_obj.limit"
            :loading="implementer_obj.loading"
            v-model="participants_sel"
            :options="participant_obj.items"
            :total="participant_obj.total"
            @keyup="emitEventParticipant"
            @scroll="emitEventParticipant"
            @offset="changeOffsetParticipant"
          />
          <input class="input_tmp_validator" id="participant" />
        </div>
        <div class="mt-3">
          <label v-for="(item, index) in participants" :key="index" class="cus-tags">
            <span class="cs-tag">
              {{item.name}}
            </span>
            <i class="fas fa-times cs-icon" v-on:click="removeParticipants(index)"></i>
          </label>
        </div>
        <div class="mt-3">
          <label class="txt-right">Người tham gia khác</label>
          <InputText
            v-model="implementer_name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="implementer_name" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Người đánh giá lại</label>
          <DropdownScrollable
            placeholder="Chọn"
            :showClear="true"
            cusClass="text-box m-0"
            width="100%"
            :multiple="false"
            :limit="re_review_obj.limit"
            :loading="re_review_obj.loading"
            v-model="re_review"
            :options="re_review_obj.items"
            :total="re_review_obj.total"
            onlyClick
            @keyup="emitEventRereview"
            @scroll="emitEventRereview"
            @offset="changeOffsetRereview"
          />
          <input class="input_tmp_validator" id="re_review" />
        </div>
        <div class="mt-3">
          <label class="txt-right">Danh sách mối nguy</label><br>
          <span class="cus-number">{{tinhhuong.length}}</span> tình huống - <span class="cus-number">{{moinguy.length}}</span> mối nguy
        </div>
        <div class="mt-3">
        <table id="tb_level">
            <tr>
              <th style="width: 50px;">STT</th>
              <th class="cus-r">Tình huống công việc</th>
              <th class="cus-r">Phân loại tình huống</th>
              <th class="cus-r">Danh mục mối nguy</th>
              <th class="cus-r">Mối nguy</th>
              <th class="cus-r">R<sub>b</sub></th>
              <th class="cus-r">BPKS</th>
              <th class="cus-r">R<sub>e</sub></th>
              <th class="cus-r">R<sub>a</sub></th>
              <th class="cus-r">Mức độ hiện tại</th>
              <th class="cus-r">Người cập nhật</th>
              <th class="cus-r">Ngày cập nhật</th>
              <th style="width: 85px;text-align: center;">
                <Button
                  @click="ShowAddItem"
                  icon="pi pi-plus"
                  class="button-box p-button-add"
                />
              </th>
            </tr>
            <tr v-for="(item, index) in evaluation_form_danger" :key="index">
              <td>{{index+1}}</td>
              <td>{{item.situation.type=='other' ? item.other_situation_name : item.situation.name}}</td>
              <td>{{item.type?.name}}</td>
              <td>{{item.category?.name}}</td>
              <td>{{item.danger.type=='other' ? item.other_danger_name :item.danger.name}}</td>
              <td><a class="txt-link-popup" @click="ShowPopup(item,'rb')">{{formatNumber(item.point_rb,0)}}</a></td>
              <td v-if="mode=='edit' && $store.getters.controllers?.control_measures && $store.getters.controllers?.control_measures.includes('list')"><a class="txt-link-bpks" @click="goPgaeControlMeasures(item)">{{formatNumber(item.bpks.total_approve,0)}}/{{formatNumber(item.bpks.total,0)}}</a></td>
              <td v-else><a>{{formatNumber(item.bpks.total_approve,0)}}/{{formatNumber(item.bpks.total,0)}}</a></td>
              <td><a class="txt-link-popup" @click="ShowPopup(item,'re')">{{formatNumber(item.point_re,0)}}</a></td>
              <td><a class="txt-link-popup" @click="ShowPopup(item,'ra')">{{formatNumber(item.point_ra,0)}}</a></td>
              <td>{{item.code_re}}</td>
              <td>{{item.user?.fullname}}</td>
              <td>{{item.date_update}}</td>
              <td style="text-align: center;">
                <Button v-if="$store.getters.controllers?.list_danger && $store.getters.controllers?.list_danger.includes('edit')"
                  @click="EditItem(index)"
                  icon="pi pi-pencil"
                  class="button-box p-button-edit"
                  style="margin: 2px;"
                />
                <Button v-if="$store.getters.controllers?.list_danger && $store.getters.controllers?.list_danger.includes('delete')"
                  @click="deleteItem(index)"
                  icon="pi pi-trash"
                  class="button-box p-button-danger"
                  style="margin: 2px;"
                />
                <Button v-if="mode=='edit' && $store.getters.controllers?.list_danger && $store.getters.controllers?.list_danger.includes('history')"
                  @click="goHistory(item)"
                  class="button-box p-button-history p-button-icon-only"
                  style="margin: 2px;height: 30px;"
                ><span class="material-icons" style="font-size: 22px;">history</span></Button>
                <Button v-if="mode=='edit' && getShowEvaluate(item) == true"
                  @click="goEvaluate(item)"
                  icon="pi pi-trash"
                  class="button-box p-button-evaluate p-button-icon-only"
                  style="margin: 2px;height: 30px;"
                ><svg
                    class="material-design-icon__svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 25">
                    <path d="M18,9 L16.59,7.58 L10,14.17 L7.41,11.59 L6,13 L10,17 L18,9 Z M19,3 L14.82,3 C14.4,1.84 13.3,1 12,1 C10.7,1 9.6,1.84 9.18,3 L5,3 C4.86,3 4.73,3.01 4.6,3.04 C4.21,3.12 3.86,3.32 3.59,3.59 C3.41,3.77 3.26,3.99 3.16,4.23 C3.06,4.46 3,4.72 3,5 L3,19 C3,19.27 3.06,19.54 3.16,19.78 C3.26,20.02 3.41,20.23 3.59,20.42 C3.86,20.69 4.21,20.89 4.6,20.97 C4.73,20.99 4.86,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,5 C21,3.9 20.1,3 19,3 Z M12,2.75 C12.41,2.75 12.75,3.09 12.75,3.5 C12.75,3.91 12.41,4.25 12,4.25 C11.59,4.25 11.25,3.91 11.25,3.5 C11.25,3.09 11.59,2.75 12,2.75 Z M19,19 L5,19 L5,5 L19,5 L19,19 Z" fill="#fcfcfc"></path>
                  </svg>
                </Button>
              </td>
            </tr>
          </table>
        </div>
        <!-- <div class="mt-3 d-flex align-items-center">
          <Checkbox v-model="active" :binary="true" />Hiển thị
        </div> -->
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>

    <Dialog :header="hearderTitle()" :visible.sync="showAddDialog" :contentStyle="{overflow: 'visible'}" :modal="true" class="dialog-min">
        <div class="">
          <label class="txt-right">Tình huống công việc<span class="required"></span></label>
          <DropdownScrollable placeholder="Chọn" :showClear="true" width="100%" cusClass="m-0"
            :multiple="false"
            :limit="situation_obj.limit"
            :loading="situation_obj.loading"
            v-model="situation"
            :options="situation_obj.items"
            :total="situation_obj.total"
            @keyup="emitEventSituation"
            @scroll="emitEventSituation"
            @offset="changeOffsetSituation"
            />
          <input class="input_tmp_validator" id="situation" />
        </div>
        <div v-if="situation && situation.type=='other'" class="">
          <label class="txt-right">Tên tình huống khác<span class="required"></span></label>
          <InputText
            v-model="other_situation_name"
            type="text"
            class="input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="other_situation_name" />
        </div>
        <div class="">
          <label class="txt-right">Phân loại tình huống<span class="required"></span></label>
          <DropdownScrollable defaultLabel="name" :showClear="false" readonly cusClass="m-0" width="100%" v-model="type_situation" :options="type_situation_list"/>

          <!-- <DropdownScrollable placeholder="Chọn" :showClear="false" width="100%" cusClass="m-0"
            v-model="type_situation"
            :options="type_situation_list"
          /> -->
          <input class="input_tmp_validator" id="type_situation" />
        </div>
        <div class="">
          <label class="txt-right">Danh mục mối nguy<span class="required"></span></label>
          <DropdownScrollable placeholder="Chọn" :showClear="true" width="100%" cusClass="m-0"
            :multiple="false"
            :limit="category_obj.limit"
            :loading="category_obj.loading"
            v-model="category"
            :options="category_obj.items"
            :total="category_obj.total"
            @keyup="emitEventCategory"
            @scroll="emitEventCategory"
            @offset="changeOffsetCategory"
            />
          <input class="input_tmp_validator" id="category" />
        </div>
        <div class="">
          <label class="txt-right">Mối nguy<span class="required"></span></label>
          <DropdownScrollable placeholder="Chọn" :showClear="true" width="100%" cusClass="m-0"
            :multiple="false"
            :limit="danger_obj.limit"
            :loading="danger_obj.loading"
            v-model="danger"
            :options="danger_obj.items"
            :total="danger_obj.total"
            @keyup="emitEventDanger"
            @scroll="emitEventDanger"
            @offset="changeOffsetDanger"
            />
          <input class="input_tmp_validator" id="danger" />
        </div>
        <div v-if="danger && danger.type=='other'" class="">
          <label class="txt-right">Khác<span class="required"></span></label>
          <InputText
            v-model="other_danger_name"
            type="text"
            class="input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="other_danger_name" />
        </div>
        
      <template #footer>
        <Button label="Hủy" @click="showAddDialog = false" icon="pi pi-times" class="p-button-cancel" />
        <Button v-if="mode=='add'" label="Xác nhận" @click="AddData()" icon="pi pi-check" class="" />
        <Button v-else label="Xác nhận" @click="EditData()" icon="pi pi-check" class="" />
      </template>
    </Dialog>

    <Dialog
      style=""
      header="Xóa"
      :visible.sync="showDeleteDialog"
      :contentStyle="{overflow: 'visible'}"
      :modal="true"
    >
      Bạn có chắc muốn xóa mối nguy này không này không?
      <template
        #footer
      >
      <Button
      label="Hủy"
      @click="showDeleteDialog = false"
      icon="pi pi-times"
      class="p-button-warning callback-btn"
      />
      <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
      </template>
    </Dialog>
    <Dialog
      style=""
      header="Chi tiết đánh giá rủi ro"
      :visible.sync="showDetailDialog"
      :contentStyle="{overflow: 'visible'}"
      :modal="true"
    >
      <table style="width:360px">
        <tr>
          <th style="width: 20%;">Tiêu chí</th>
          <th style="width: 20%;">Điểm</th>
          <th>Mức độ</th>
        </tr>
        <tr v-for="(item, index) in data_popup.list" :key="index">
          <td style="vertical-align: top;">{{item.code}}</td>
          <td style="vertical-align: top;">{{item.point}}</td>
          <td style="vertical-align: top;">{{item.name}}</td>
        </tr>
        <tr style="height: 34px;vertical-align: bottom;">
          <td>R</td>
          <td>{{data_popup.point}}</td>
          <td>{{data_popup.code}}</td>
        </tr>
      </table>
      <template
        #footer
      >
      <Button label="Đóng" icon="pi pi-check" class="p-button-success main-style-button"
        @click="showDetailDialog = false"
      />
      </template>
    </Dialog>
  </form>
</template>

<script>
import moment from "moment-timezone";
import ApiRepository from "@/core/ApiRepository";
import DropdownScrollable from '@/components/DropdownScrollable_v2';
export default {
  components: {
    DropdownScrollable
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
    company_id: String
  },
  data() {
    return {
      time_zone_local : moment.tz.guess(true),
      name: "",
      showDeleteDialog : false,
      active: true,
      company: null,
      company_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      areas_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      department_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      department : null,
      areas : null,
      uid: null,
      work_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      work : null,
      expiration_date : null,
      approve : null,
      approve_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      review_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      review : null,
      implementer : null,
      implementer_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      participant_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      participants : [],
      implementer_name : '',
      re_review_obj :{
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      re_review : null,
      evaluation_form_danger : [
        // {
        //   index : 1,
        //   situation : {id : 1,name:"nameeeeee"}, 
        //   type : {value : "Thường xuyên",name : "Thường xuyên"},
        //   category : {id : "21add",name : "Ten6666666"},
        //   danger : {id : "dsadsada",name : "Mối nguy"},
        //   rb : "25",
        //   bpks : "0/0",
        //   re : "1",
        //   ra : "2",
        //   criteria : {code : "A", type : "POINT"},
        //   user : {id : "22qe",fullname:"Người cập nhật"},
        //   date_update: "Ngày cập nhật",
        //   ordinal : 1
        // }
      ],
      tinhhuong : [],
      moinguy : [],
      showAddDialog : false,
      situation : null,
      situation_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      type_situation_list : [{id : "PERIODIC" , name : "Định kỳ"},{id : "ABMORMAL" , name : "Bất thường"},{id : "FREQUENT" , name : "Thường xuyên"}],
      type_situation : {id : "PERIODIC" , name : "Định kỳ"},
      category_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      category : null,
      danger_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      danger : null,
      other_danger_name : '',
      other_situation_name : '',
      is_load_data : false,
      is_load_popup : false,
      item_edit_index : null,
      id_edit : null,
      hearder_title : 'Thêm mối nguy',
      index_edit : -1,
      deleteId : null,
      deleteIndex : -1,
      data_popup :{
        list : [],
        point : null,
        code :""
      },
      showDetailDialog : false,
      situation_ref_id : null,
      danger_ref_id : null,
      copy_company_id : null,
      copy_id : null,
      checkshowEval : false,
      participants_sel : null,
    }
  },
  async mounted() {
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.company_obj = {
        offset: 0,
        filters: {},
        limit: 0,
        items: [this.model.company],
        total: 1,
        loading: false
      }
      if(this.mode == 'add'){
        setTimeout(async () => {
          this.is_load_data = true
          // console.log("this.model==",this.model)
          this.company = this.model.company;
          this.getListAreas();
          this.name = 'Bản sao của '+this.model.name;
          var time_date = new Date(this.model.expiration_date)
          this.expiration_date = time_date;
          this.implementer_name = this.model.implementer_name
          setTimeout(async () => {
            this.areas = this.model.areas;
          }, 200);
          this.department = this.model.department;
          await this.getListDepartment();
          await this.getListWork();
          await this.getListApprove();
          await this.getListReview();
          await this.getListImplementer();
          await this.getListParticipant();
          await this.getListRereview();
          this.work = this.model.work;
          this.approve = this.model.approve
          this.review = this.model.review
          this.implementer = this.model.implementer
          this.participants = this.model.evaluation_form_participants
          this.re_review = this.model.re_review
          this.is_load_data = false
          await this.getListEvaluationDangerCopy(this.model.id)
        }, 50);
      }else{
        setTimeout(async () => {
          this.is_load_data = true
          // console.log("this.model==",this.model)
          this.company = this.model.company;
          this.getListAreas();
          this.name = this.model.name;
          var time_date = null
          if(this.model.expiration_date){
            time_date = new Date(this.model.expiration_date)
          }
          this.expiration_date = time_date;
          this.implementer_name = this.model.implementer_name
          setTimeout(async () => {
            this.areas = this.model.areas;
          }, 200);
          // await this.getListDepartment();
          // await this.getListWork();
          this.department = this.model.department;
          await this.getListApprove();
          await this.getListReview();
          await this.getListImplementer();
          await this.getListParticipant();
          await this.getListRereview();
          this.work = this.model.work;
          this.approve = this.model.approve
          this.review = this.model.review
          this.implementer = this.model.implementer
          this.participants = this.model.evaluation_form_participants
          this.re_review = this.model.re_review
          this.is_load_data = false

          let user_id = this.$store.getters.user;
          if(this.model.status == 'NEW'){
            if(this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN || this.$store.getters.type == this.$constants.TYPE_USER.COMPANY){
              this.checkshowEval = true
            }else if(user_id == this.model.uid_implementer){
              this.checkshowEval = true
            }
          }else if(this.model.status == 'REVIEW'){
            if(this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN || this.$store.getters.type == this.$constants.TYPE_USER.COMPANY){
              this.checkshowEval = true
            }else if(user_id == this.model.uid_review){
              this.checkshowEval = true
            }
          }else if(this.model.status == 'WAITTING_APPROVED'){
            if(this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN || this.$store.getters.type == this.$constants.TYPE_USER.COMPANY){
              this.checkshowEval = true
            }else if(user_id == this.model.uid_approve){
              this.checkshowEval = true
            }
          }else if(this.model.status == 'APPROVE'){
            if(this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN){
              this.checkshowEval = true
            }else if(this.$store.getters.type == this.$constants.TYPE_USER.COMPANY){
              if(this.$store.getters.controllers?.evaluation_form && this.$store.getters.controllers?.evaluation_form.includes('close')){
                this.checkshowEval = true
              }
            }else if(this.$store.getters.controllers?.evaluation_form && this.$store.getters.controllers?.evaluation_form.includes('close')){
              this.checkshowEval = true
            }
          }

          await this.getListEvaluationDanger()
        }, 50);
      }
    }else{
      await this.getListCompany();
    }
    
  },
  watch: {
    async "company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company = {id: this.company_id};
        console.log("watch company_id", this.company);
        await this.getListAreas();
        await this.getListDepartment();
        // await this.getListWork();
        await this.getListApprove();
        await this.getListReview();
        await this.getListImplementer();
        await this.getListParticipant();
        await this.getListRereview();
      }
    },
    async "$store.getters.company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        this.company = {id: this.company_id};
        console.log("watch store company_id", this.company);
        await this.getListAreas();
        await this.getListDepartment();
        // await this.getListWork();
        await this.getListApprove();
        await this.getListReview();
        await this.getListImplementer();
        await this.getListParticipant();
        await this.getListRereview();
      }
    },
    async "company"() {
      this.participants_sel = null
      console.log("change company")
      if(this.is_load_data == false){
        await this.clearChangeCompany()
        await this.getListAreas();
        await this.getListDepartment();
        await this.getListApprove();
        await this.getListReview();
        await this.getListImplementer();
        await this.getListParticipant();
        await this.getListRereview();
      }
    },
    async "department"() {
      // console.log("this.company",this.department)
      if(this.is_load_data == false){
        this.clearWork()
        await this.getListWork();
      }
    },
    async "category"() {
      if(this.is_load_popup == false){
        this.clearDanger()
        await this.getListDanger();
      }
    },
    async "work"() {
      if(this.is_load_data == false){
        this.clearSituation()
        this.clearCategory()
        this.clearDanger()
        this.clearEvaluationFormDanger()
      }
    },
    async "participants_sel"() {
      if(this.$commonFuction.isEmptyObject(this.participants_sel)){
        return
      }else{
        var check_exist = false;
        for (let i = 0; i < this.participants.length; i++) {
          if(this.participants[i].id == this.participants_sel.id){
            check_exist = true;
            break;
          }
        }
        if(check_exist == false){
          this.participants.push(this.participants_sel)
        }
        this.participants_sel = null
      }
    },
  },
  methods: {
    async EditItem(index){
      this.item_edit_index = index
      //gán lại default
      this.id_edit = null
      this.situation_ref_id = null
      this.danger_ref_id = null
      this.index_edit = -1
      //gán lại default
      if(this.$commonFuction.isEmptyObject(this.work)) {
        alert("Vui lòng chọn công việc trước!")
        return;
      }
      var data_edit = this.evaluation_form_danger[index]
      this.id_edit = data_edit.id ? data_edit.id : null
      this.situation_ref_id = data_edit.situation_ref_id ?? null
      this.danger_ref_id = data_edit.danger_ref_id ?? null
      this.index_edit = index
      // console.log("data_edit==",data_edit)
      this.clearSituation()
      this.clearCategory()
      this.clearDanger()
      this.clearValidate()
      this.hearder_title = 'Cập nhật mối nguy'
      this.showAddDialog = true
      
      await this.getListSituation();
      await this.getListCategory();
      
      this.is_load_popup = true

      this.situation = data_edit.situation
      
      this.category = data_edit.category
      await this.getListDanger();
      this.type_situation = data_edit.type
      this.danger = data_edit.danger
      this.other_danger_name = data_edit.other_danger_name
      this.other_situation_name = data_edit.other_situation_name
      
      this.is_load_popup = false
    },
    async getListEvaluationDanger(){
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return false;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      var list = []
      
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        }
        await ApiRepository.post("/_api/evaluation_form_danger/all", {evaluation_form_id: this.$route.params.id,company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list ?? []
            list = tmp
        }).catch((err) => {
            console.log(err);
        })
        
      }
      this.ListEvaluationDanger(list)
    },
    async getListEvaluationDangerCopy(id){
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return false;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      var list = []
      
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        }
        await ApiRepository.post("/_api/evaluation_form_danger/all", {evaluation_form_id: id,company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list ?? []
            var tmp_2 = []
            for (let i = 0; i < tmp.length; i++) {
              const e = tmp[i];
              let other_danger_name = ''
              let other_situation_name = ''
              if(e.danger?.type=='other'){
                other_danger_name = "Bản sao "+e.other_danger_name
              }
              if(e.situation?.type=='other'){
                other_situation_name = "Bản sao "+e.other_situation_name
              }
              tmp_2.push({
                situation : e.situation, 
                type : e.type,
                category : e.category,
                danger : e.danger,
                rb : "",re : "",ra : "",
                criteria : {code : "", type : ""},
                user : {id : "",fullname:""}, date_update: "",
                other_danger_name : other_danger_name,
                other_situation_name : other_situation_name,
                bpks : {
                  total_approve : 0,
                  total : 0
                }
              })
            }
            list = tmp_2
        }).catch((err) => {
            console.log(err);
        })
      }
      this.ListEvaluationDanger(list)
    },
    async ListEvaluationDanger(list){
      // console.log("list==d",list)
      var tmp = list
      for (let i = 0; i < tmp.length; i++) {
        tmp[i].date_update = moment.tz(tmp[i].updated_at, this.time_zone_local).format("DD/MM/yyyy HH:mm");
        if(tmp[i].type == 'PERIODIC'){
          tmp[i].type = {id : "PERIODIC" , name : "Định kỳ"}
        }else if(tmp[i].type == 'ABMORMAL'){
          tmp[i].type = {id : "ABMORMAL" , name : "Bất thường"}
        }else if(tmp[i].type == 'FREQUENT'){
          tmp[i].type = {id : "FREQUENT" , name : "Thường xuyên"}
        }
        if(tmp[i].point_ra >= 0){
          tmp[i].code_now = tmp[i].code_ra
        }else if(tmp[i].point_rb >= 0){
          tmp[i].code_now = tmp[i].code_rb
        }
      }
      this.evaluation_form_danger = tmp
      this.countSituationAndDanger();//đếm số lượng

    },
    async EditData(){
      this.$commonFuction.is_loading(true);
      var id_edit = this.id_edit ? this.id_edit : null
      this.other_danger_name.trim()
      this.other_situation_name.trim()
      let situation = this.situation
      let type_situation = this.type_situation
      let category = this.category
      let danger = this.danger
      let other_danger_name =  this.other_danger_name
      let other_situation_name = this.other_situation_name
      
      let check_e = await this.validateDataAdd()
      if(check_e){
        this.$commonFuction.is_loading(false);
        return
      }
      // var check_exsit_e = false
      // for (let i = 0; i < this.evaluation_form_danger.length; i++) {
      //   let e = this.evaluation_form_danger[i];
      //   if(e.id == this.id_edit){
      //     continue;
      //   }
      //   if(e.situation.id == situation.id && e.danger.id == danger.id){
      //     if(situation.type == 'normal' && danger.type == 'normal'){
      //       check_exsit_e = true;
      //       break;
      //     }
      //     var count_e = 0
      //     if(situation.type == 'other'){
      //       if(other_situation_name !== e.other_situation_name){
      //         break;
      //       }else{
      //         count_e++
      //       }
      //     }
      //     if(danger.type == 'other'){
      //       if(other_danger_name !== e.other_danger_name){
      //         break;
      //       }else{
      //         count_e++
      //       }
      //     }
      //     console.log("count_e",count_e)
      //     if(count_e == 2){
      //       check_exsit_e = true;
      //       break;
      //     }
      //   }
      // }
      var check_exsit_e = await this.checkExsit()
      if(check_exsit_e){
        this.$commonFuction.is_loading(false);
        alert("Mối nguy đã tồn tại!")
        return;
      }
      //gọi api cập nhật
      let objects = {
        evaluation_form_id : this.$route.params.id,
        work_id : this.work.id,
        danger : danger,
        situation : situation,
        type : type_situation.id,
        category_id : category.id,
        other_danger_name : other_danger_name,
        other_situation_name : other_situation_name,
        company_id : this.company.id,
      }
      if(id_edit){
        objects.id = this.id_edit
      }

      var token = this.$store.getters.token ? this.$store.getters.token : null
      var that = this
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        await ApiRepository.post("/_api/evaluation_form_danger/update", objects, {headers}).then(async function (response) {
          if (response.status === 200) {
            that.reloadData();
          } else {
            that.$toast.add({
                severity: 'error',
                summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: response.data.message,
                life: 3000
            });
            that.$commonFuction.is_loading(false);
          }
        }).catch((err) => {
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
          that.$commonFuction.is_loading(false);
        })
      }
      this.id_edit = null
    },
    async reloadData(){
      this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Lưu dữ liệu thành công', life: 3000 })
      // this.evaluation_form_danger = []
      await this.getListEvaluationDanger()
      this.showAddDialog = false
      this.$commonFuction.is_loading(false);
    },
    async AddData(){
      this.$commonFuction.is_loading(true);
      this.other_danger_name.trim()
      this.other_situation_name.trim()
      var check = await this.validateDataAdd()
      if(check){
        this.$commonFuction.is_loading(false);
        return
      }
      //tạo mới
      var situation = this.situation
      var type_situation = this.type_situation
      var category = this.category
      var danger = this.danger
      var other_danger_name =  this.other_danger_name
      var other_situation_name = this.other_situation_name

      //kiểm tra có trùng với danh bên dưới không
      var check_exsit = false
      var check_situation = false
      var check_danger = false
      for (let i = 0; i < this.evaluation_form_danger.length; i++) {
        if(i == this.index_edit){
          continue;
        }
        let e = this.evaluation_form_danger[i];
        if(e.situation.id == situation.id && e.danger.id == danger.id){
          if(situation.type == 'normal' && danger.type == 'normal'){
            check_exsit = true;
            break;
          }else if(situation.type == 'other' && danger.type == 'other'){
            if(other_situation_name.toLowerCase() == e.other_situation_name.toLowerCase() && other_danger_name.toLowerCase() == e.other_danger_name.toLowerCase()){
              check_exsit = true;
              break;
            }
          }else if(situation.type == 'other' && danger.type == 'normal'){
            if(other_situation_name.toLowerCase() == e.other_situation_name.toLowerCase()){
              check_exsit = true;
              break;
            }
          }else if(danger.type == 'other' && e.situation.id == situation.id){
            if(other_danger_name.toLowerCase() == e.other_danger_name.toLowerCase()){
              check_exsit = true;
              break;
            }
          }
        }
        if(situation.type == 'other'){
          if(other_situation_name.toLowerCase() == e.other_situation_name.toLowerCase()){
            check_situation = true
            break;
          }
        }
        if(danger.type == 'other'){
          if(other_danger_name.toLowerCase() == e.other_danger_name.toLowerCase()){
            check_danger = true
            break;
          }
        }
      }
      if(check_exsit){
        this.$commonFuction.is_loading(false);
        alert("Mối nguy đã tồn tại!")
        return;
      }
      if(check_situation){
        this.$commonFuction.is_loading(false);
        alert("Tên Tên tình huống khác không được trùng với tên đã thêm trước đó!")
        return;
      }
      if(check_danger){
        this.$commonFuction.is_loading(false);
        alert("Tên mối nguy khác không được trùng với tên đã thêm trước đó!")
        return;
      }
      if(this.index_edit >= 0){
        this.evaluation_form_danger[this.index_edit] = {
          situation : situation, 
          type : type_situation,
          category : category,
          danger : danger,
          rb : "",re : "",ra : "",
          criteria : {code : "", type : ""},
          user : {id : "",fullname:""}, date_update: "",
          other_danger_name : other_danger_name,
          other_situation_name : other_situation_name,
          bpks : {
            total_approve : 0,
            total : 0
          }
        }
        this.index_edit = -1
      }else{
        var tmp = [{
          situation : situation, 
          type : type_situation,
          category : category,
          danger : danger,
          rb : "",re : "",ra : "",
          criteria : {code : "", type : ""},
          user : {id : "",fullname:""}, date_update: "",
          other_danger_name : other_danger_name,
          other_situation_name : other_situation_name,
          bpks : {
            total_approve : 0,
            total : 0
          }
        }]
        tmp.push(...this.evaluation_form_danger)
        this.evaluation_form_danger = tmp
      }
      this.showAddDialog = false
      this.countSituationAndDanger()
      this.$commonFuction.is_loading(false);
    },
    async CheckNameSituation(){
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return false;
      }
      if (this.$commonFuction.isEmptyObject(this.work)) {
        return false;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        var check = false
        await ApiRepository.post("/_api/situation/check_name", {situation_id : this.situation_ref_id,work_id: this.work.id,name:this.other_situation_name,company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.data
            if(tmp && tmp.id){
              check = true
            }
        }).catch((err) => {
            console.log(err);
        })
        return check
      }
    },
    async CheckNameDanger(){
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return false;
      }
      if (this.$commonFuction.isEmptyObject(this.category)) {
        return false;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        var check = false
        await ApiRepository.post("/_api/danger/check_name", {danger_id:this.danger_ref_id,category_id: this.category.id,name:this.other_danger_name,company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.data
            if(tmp && tmp.id){
              check = true
            }
        }).catch((err) => {
            console.log(err);
        })
        return check
      }
    },
    async validateDataAdd(){
      let situation_add = document.getElementById("situation");
      if (this.$commonFuction.isEmptyObject(this.situation) ||
        this.$commonFuction.isEmpty(this.situation)) {
        situation_add.setCustomValidity("Tình huống công việc không được để trống!");
      } else {
        if(this.situation.type == "other"){
          let other_situation_name_add = document.getElementById("other_situation_name")
          if (this.other_situation_name == undefined || this.other_situation_name == null || this.other_situation_name == ""
          ) {
            other_situation_name_add.setCustomValidity("Tên tình huống khác không được để trống!");
          } else if (this.other_situation_name.length > 255) {
            other_situation_name_add.setCustomValidity("Tên tình huống khác không được quá 255 ký tự!");
          } else {
            //kiểm tra tên đã tồn tại chưa
            var check_name = await this.CheckNameSituation()
            // console.log("check_name",check_name)
            if(check_name || this.other_situation_name.toLowerCase() == 'khác'){
              other_situation_name_add.setCustomValidity("Tên tình huống đã tồn tại trên hệ thống");
            }else {
              other_situation_name_add.setCustomValidity("");
            }
          }
        }
        situation_add.setCustomValidity("");
      }
      let type_situation_add = document.getElementById("type_situation");
      
      if (!this.type_situation) {
        type_situation_add.setCustomValidity("Phân loại tình huống không được để trống!");
      } else {
        type_situation_add.setCustomValidity("");
      }
      let category_add = document.getElementById("category");
      if (this.$commonFuction.isEmptyObject(this.category) ||
        this.$commonFuction.isEmpty(this.category)) {
        category_add.setCustomValidity("Danh mục mối nguy không được để trống!");
      } else {
        category_add.setCustomValidity("");
      }
      let danger_add = document.getElementById("danger");
      if (this.$commonFuction.isEmptyObject(this.danger) || this.$commonFuction.isEmpty(this.danger)) {
        danger_add.setCustomValidity("Mối nguy không được để trống!");
      } else {
        if(this.danger.type == "other"){
          let other_danger_name_add = document.getElementById("other_danger_name")
          if (this.other_danger_name == undefined || this.other_danger_name == null || this.other_danger_name == ""
          ) {
            other_danger_name_add.setCustomValidity("Tên mối nguy khác không được để trống!");
          } else if (this.other_danger_name.length > 255) {
            other_danger_name_add.setCustomValidity("Tên mối nguy khác không được quá 255 ký tự!");
          } else {
            //kiểm tra tên đã tồn tại chưa
            var check_name_danger = await this.CheckNameDanger()
            if(check_name_danger || this.other_danger_name.toLowerCase() == 'khác'){
              other_danger_name_add.setCustomValidity("Tên mối nguy đã tồn tại trên hệ thống");
            }else {
              other_danger_name_add.setCustomValidity("");
            }
          }
        }
        danger_add.setCustomValidity("");
      }
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    deleteItem(index) {
      // var index = this.index_deleted
      this.showDeleteDialog = true
      var evaluation_form_danger = this.evaluation_form_danger[index];
      this.deleteIndex = index
      this.deleteId = evaluation_form_danger?.id
      // if(evaluation_form_danger.id){
      //   this.evaluation_form_danger_deleted.push(evaluation_form_danger.id)
      // }
      // this.evaluation_form_danger.splice(index, 1)
      // this.countSituationAndDanger()
    },
    async deleteData() {
      if(this.deleteId){
        this.showDeleteDialog = false
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
          const headers = {
            "Authorization": "Bearer "+token,
          };
          var that = this;
          await ApiRepository.post("/_api/evaluation_form_danger/delete", {id: that.deleteId, company_id: that.company.id}, {headers}).then(function () {
            that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa thành công', life: 3000 })
            that.componentKey += 1;
          }).catch((err) => {
            that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
            })
          })
        }
        await this.getListEvaluationDanger()
      }else{
        this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa thành công', life: 3000 })
        this.evaluation_form_danger.splice(this.deleteIndex, 1)
        this.showDeleteDialog = false
        this.countSituationAndDanger()
      }
      
    },
    countSituationAndDanger(){
      var th = []
      var mn = []
      for (let i = 0; i < this.evaluation_form_danger.length; i++) {
        var situation = this.evaluation_form_danger[i].situation
        var danger = this.evaluation_form_danger[i].danger
        if(!th.includes(situation.id)){
          th.push(situation.id)
        }
        if(!mn.includes(danger.id)){
          mn.push(danger.id)
        }
      }
      this.tinhhuong = th
      this.moinguy = mn
    },
    async ShowAddItem(){
      if(this.$commonFuction.isEmptyObject(this.work)) {
        alert("Vui lòng chọn công việc trước!")
        return;
      }
      this.clearSituation()
      this.clearCategory()
      this.clearDanger()
      this.clearValidate()
      this.hearder_title = 'Thêm mối nguy'
      this.showAddDialog = true
      setTimeout(() => {
        this.type_situation = {id : "PERIODIC" , name : "Định kỳ"};
      }, 500);
      // this.type_situation = {id : "PERIODIC" , name : "Định kỳ"}
      await this.getListSituation();
      await this.getListCategory();
    },
    clearValidate(){
      if(this.mode=='edit'){
        document.getElementById("name").setCustomValidity("")
      }
      document.getElementById("areas").setCustomValidity("")
      document.getElementById("department").setCustomValidity("")
      document.getElementById("expiration_date").setCustomValidity("")
      document.getElementById("approve").setCustomValidity("")
      document.getElementById("review").setCustomValidity("")
      document.getElementById("implementer").setCustomValidity("")
      document.getElementById("participant").setCustomValidity("")
      document.getElementById("re_review").setCustomValidity("")
    },
    clearValidateAdd(){
      document.getElementById("situation").setCustomValidity("")
      // if(this.situation && this.situation.type == 'other'){
      this.other_situation_name = ''
      //   document.getElementById("other_situation_name").setCustomValidity("")
      // }
      document.getElementById("type_situation").setCustomValidity("")
      document.getElementById("category").setCustomValidity("")
      document.getElementById("danger").setCustomValidity("")
      // if(this.danger && this.danger.type == 'other'){
      this.other_danger_name = ''
      //   document.getElementById("other_danger_name").setCustomValidity("")
      // }
    },
    emitEventDanger(keyword) {
      // console.log(keyword);
      this.$delete(this.danger_obj.filters, 'name');
      if (keyword) {
        this.danger_obj.filters.name = keyword;
      }
      this.getListDanger();
    },
    changeOffsetDanger(value) {
      this.danger_obj.offset = value;
    },
    async getListDanger() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      if(this.$commonFuction.isEmptyObject(this.category)) {
        return;
      }
      this.danger_obj.filters.category_id = this.category.id
      this.danger_obj.filters.active = true
      this.danger_obj.filters.status = 'APPROVED'
      this.danger_obj.filters.get_other = true
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.danger_obj.loading = true;
        await ApiRepository.post("/_api/danger/options", {filters: this.danger_obj.filters, limit: this.danger_obj.limit, offset: this.danger_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            if (this.danger_obj.offset > 0 ) {
              this.danger_obj.items.push(...tmp);
            } else{
              this.danger_obj.items= tmp;
            }
            this.danger_obj.total = res.data.data.total;
            this.danger_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.danger_obj.loading = false;
        })
      }
    },
    emitEventCategory(keyword) {
      // console.log(keyword);
      this.$delete(this.category_obj.filters, 'name');
      if (keyword) {
        this.category_obj.filters.name = keyword;
      }
      this.getListCategory();
    },
    changeOffsetCategory(value) {
      this.category_obj.offset = value;
    },
    async getListCategory() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.category_obj.loading = true;
        await ApiRepository.post("/_api/category/options", {filters: this.category_obj.filters, limit: this.category_obj.limit, offset: this.category_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            if (this.category_obj.offset > 0 ) {
              this.category_obj.items.push(...tmp);
            } else{
              this.category_obj.items = tmp;
            }
            this.category_obj.total = res.data.data.total;
            this.category_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.category_obj.loading = false;
        })
      }
    },
    emitEventSituation(keyword) {
      // console.log(keyword);
      this.$delete(this.situation_obj.filters, 'name');
      if (keyword) {
        this.situation_obj.filters.name = keyword;
      }
      this.getListSituation();
    },
    changeOffsetSituation(value) {
      this.situation_obj.offset = value;
    },
    async getListSituation() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      if(this.$commonFuction.isEmptyObject(this.work)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      this.situation_obj.filters.work_id = this.work.id
      this.situation_obj.filters.active = true
      this.situation_obj.filters.status = 'APPROVED'
      this.situation_obj.filters.get_other = true
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.situation_obj.loading = true;
        await ApiRepository.post("/_api/situation/options", {filters: this.situation_obj.filters, limit: this.situation_obj.limit, offset: this.situation_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            if (this.situation_obj.offset > 0 ) {
              this.situation_obj.items.push(...tmp);
            } else{
              this.situation_obj.items = tmp;
            }
            this.situation_obj.total = res.data.data.total;
            this.situation_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.situation_obj.loading = false;
        })
      }
    },
    emitEventRereview(keyword) {
      // console.log(keyword);
      this.$delete(this.re_review_obj.filters, 'name');
      if (keyword) {
        this.re_review_obj.filters.name = keyword;
      }
      this.getListRereview();
    },
    changeOffsetRereview(value) {
      this.re_review_obj.offset = value;
    },
    async getListRereview() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.re_review_obj.loading = true;
        await ApiRepository.post("/_api/users/options", {filters: this.re_review_obj.filters, limit: this.re_review_obj.limit, offset: this.re_review_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.re_review_obj.offset > 0 ) {
              this.re_review_obj.items.push(...tmp);
            } else{
              this.re_review_obj.items = tmp;
            }
            
            this.re_review_obj.total = res.data.data.count;
            this.re_review_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.re_review_obj.loading = false;
        })
      }
    },
    emitEventParticipant(keyword) {
      // console.log(keyword);
      this.$delete(this.participant_obj.filters, 'name');
      if (keyword) {
        this.participant_obj.filters.name = keyword;
      }
      this.getListParticipant();
    },
    changeOffsetParticipant(value) {
      this.participant_obj.offset = value;
    },
    async getListParticipant() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.participant_obj.loading = true;
        await ApiRepository.post("/_api/users/options", {filters: this.participant_obj.filters, limit: this.participant_obj.limit, offset: this.participant_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.participant_obj.offset > 0 ) {
              this.participant_obj.items.push(...tmp);
            } else{
              this.participant_obj.items = tmp;
            }
            
            this.participant_obj.total = res.data.data.count;
            this.participant_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.participant_obj.loading = false;
        })
      }
    },
    emitEventImplementer(keyword) {
      // console.log(keyword);
      this.$delete(this.implementer_obj.filters, 'name');
      if (keyword) {
        this.implementer_obj.filters.name = keyword;
      }
      this.getListImplementer();
    },
    changeOffsetImplementer(value) {
      this.implementer_obj.offset = value;
    },
    async getListImplementer() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.implementer_obj.loading = true;
        await ApiRepository.post("/_api/users/options", {filters: this.implementer_obj.filters, limit: this.implementer_obj.limit, offset: this.implementer_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.implementer_obj.offset > 0 ) {
              this.implementer_obj.items.push(...tmp);
            } else{
              this.implementer_obj.items = tmp;
            }
            
            this.implementer_obj.total = res.data.data.count;
            this.implementer_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.implementer_obj.loading = false;
        })
      }
    },
    emitEventReview(keyword) {
      // console.log(keyword);
      this.$delete(this.review_obj.filters, 'name');
      if (keyword) {
        this.review_obj.filters.name = keyword;
      }
      this.getListReview();
    },
    changeOffsetReview(value) {
      this.review_obj.offset = value;
    },
    async getListReview() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.review_obj.loading = true;
        await ApiRepository.post("/_api/users/options", {filters: this.review_obj.filters, limit: this.review_obj.limit, offset: this.review_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.review_obj.offset > 0 ) {
              this.review_obj.items.push(...tmp);
            } else{
              this.review_obj.items = tmp;
            }
            
            this.review_obj.total = res.data.data.count;
            this.review_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.review_obj.loading = false;
        })
      }
    },
    emitEventApprove(keyword) {
      // console.log(keyword);
      this.$delete(this.approve_obj.filters, 'name');
      if (keyword) {
        this.approve_obj.filters.name = keyword;
      }
      this.getListApprove();
    },
    changeOffsetApprove(value) {
      this.approve_obj.offset = value;
    },
    async getListApprove() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.approve_obj.loading = true;
        await ApiRepository.post("/_api/users/options", {filters: this.approve_obj.filters, limit: this.approve_obj.limit, offset: this.approve_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.approve_obj.offset > 0 ) {
              this.approve_obj.items.push(...tmp);
            } else{
              this.approve_obj.items = tmp;
            }
            
            this.approve_obj.total = res.data.data.count;
            this.approve_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.approve_obj.loading = false;
        })
      }
    },
    emitEventWork(keyword) {
      // console.log(keyword);
      this.$delete(this.work_obj.filters, 'name');
      if (keyword) {
        this.work_obj.filters.name = keyword;
      }
      this.getListWork();
    },
    changeOffsetWork(value) {
      this.work_obj.offset = value;
    },
    async getListWork() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      if (this.$commonFuction.isEmptyObject(this.department)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      this.work_obj.filters.department_id = this.department.id
      this.work_obj.filters.active = true
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.work_obj.loading = true;
        await ApiRepository.post("/_api/work/options", {filters: this.work_obj.filters, limit: this.work_obj.limit, offset: this.work_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.work_obj.offset > 0 ) {
              this.work_obj.items.push(...res.data.data.list);
            } else{
              this.work_obj.items = res.data.data.list;
            }
            this.work_obj.total = res.data.data.total;
            this.work_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.work_obj.loading = false;
        })
      }
    },
    async clearChangeCompany(){
      this.clearDepartment()
      this.clearAreas()
      this.clearWork()
      this.clearReview()
      this.clearApprove()
      this.clearImplementer()
      this.clearParticipant()
      this.clearRereview()
      this.clearEvaluationFormDanger()
      this.clearSituation()
      this.clearCategory()
      this.clearDanger()
    },
    emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      this.getListCompany();
    },
    changeOffset(value) {
      this.company_obj.offset = value;
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.company_obj.offset > 0 ) {
            this.company_obj.items.push(...res.data.data.company);
          } else{
            this.company_obj.items = res.data.data.company;
          }
          this.company_obj.total = res.data.data.count;
          this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
        })
      }
    },
    emitEventDepartment(keyword) {
      // console.log(keyword);
      this.$delete(this.department_obj.filters, 'name');
      if (keyword) {
        this.department_obj.filters.name = keyword;
      }
      this.getListDepartment();
    },
    changeOffsetDepartment(value) {
      this.department_obj.offset = value;
    },
    async getListDepartment() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      this.department_obj.filters.active = true;
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.department_obj.loading = true;
        await ApiRepository.post("/_api/department/options", {filters: this.department_obj.filters, limit: this.department_obj.limit, offset: this.department_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.department_obj.offset > 0 ) {
              this.department_obj.items.push(...res.data.data.department);
            } else{
              this.department_obj.items = res.data.data.department;
            }
            this.department_obj.total = res.data.data.count;
            this.department_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.department_obj.loading = false;
        })
      }
    },
    emitEventAreas(keyword) {
      // console.log(keyword);
      this.$delete(this.areas_obj.filters, 'name');
      if (keyword) {
        this.areas_obj.filters.name = keyword;
      }
      this.getListAreas();
    },
    changeOffsetAreas(value) {
      this.areas_obj.offset = value;
    },
    async getListAreas() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.areas_obj.loading = true;
        await ApiRepository.post("/_api/area/options", {filters: this.areas_obj.filters, limit: this.areas_obj.limit, offset: this.areas_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.areas_obj.offset > 0 ) {
              this.areas_obj.items.push(...res.data.data.area);
            } else{
              this.areas_obj.items = res.data.data.area;
            }
            this.areas_obj.total = res.data.data.count;
            this.areas_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.areas_obj.loading = false;
        })
      }
    },
    backToList() {
      this.$emit("back");
    },
    async validateData() {
      this.validationErrors = {};
      if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        let company_add = document.getElementById("company");
        if (this.$commonFuction.isEmptyObject(this.company) || this.$commonFuction.isEmpty(this.company)) {
          company_add.setCustomValidity("Công ty không được để trống!");
        } else {
          company_add.setCustomValidity("");
        }
      }
      if(this.mode == 'edit'){
        let name_add = document.getElementById("name");
        if (
          this.name == undefined ||
          this.name == null ||
          this.name == ""
        ) {
          name_add.setCustomValidity("Phiếu đánh giá không được để trống!");
        } else if (this.name.length > 255) {
          name_add.setCustomValidity("Phiếu đánh giá không được quá 255 ký tự!");
        } else {
          name_add.setCustomValidity("");
        }
      }

      let areas_add = document.getElementById("areas");
      if (this.$commonFuction.isEmptyObject(this.areas) || this.$commonFuction.isEmpty(this.areas)) {
        areas_add.setCustomValidity("Khu vực không được để trống!");
      } else {
        areas_add.setCustomValidity("");
      }
      let department_add = document.getElementById("department");
      if (this.$commonFuction.isEmptyObject(this.department) || this.$commonFuction.isEmpty(this.department)) {
        department_add.setCustomValidity("Bộ phận không được để trống!");
      } else {
        department_add.setCustomValidity("");
      }

      let work_add = document.getElementById("work");
      if (this.$commonFuction.isEmptyObject(this.work) || this.$commonFuction.isEmpty(this.work)) {
        work_add.setCustomValidity("Công việc không được để trống!");
      } else {
        work_add.setCustomValidity("");
      }

      let expiration_date_add = document.getElementById("expiration_date");
      if (!this.expiration_date) {
        expiration_date_add.setCustomValidity("Hạn chót không được để trống!");
      } else {
        expiration_date_add.setCustomValidity("");
      }

      let approve_add = document.getElementById("approve");
      if (this.$commonFuction.isEmptyObject(this.approve) || this.$commonFuction.isEmpty(this.approve)) {
        approve_add.setCustomValidity("Người approve không được để trống!");
      } else {
        approve_add.setCustomValidity("");
      }

      let review_add = document.getElementById("review");
      if (this.$commonFuction.isEmptyObject(this.review) || this.$commonFuction.isEmpty(this.review)) {
        review_add.setCustomValidity("Người review không được để trống!");
      } else {
        review_add.setCustomValidity("");
      }

      let implementer_add = document.getElementById("implementer");
      if (this.$commonFuction.isEmptyObject(this.implementer) || this.$commonFuction.isEmpty(this.implementer)) {
        implementer_add.setCustomValidity("Người thực hiện không được để trống!");
      } else {
        implementer_add.setCustomValidity("");
      }
      let participant_add = document.getElementById("participant");
      if (this.$commonFuction.isEmptyObject(this.participants) || this.participants.length == 0) {
        participant_add.setCustomValidity("Người tham gia không được để trống!");
      } else {
        participant_add.setCustomValidity("");
      }

      let implementer_name = document.getElementById("implementer_name");
      if (this.implementer_name == undefined || this.implementer_name == null || this.implementer_name == "") {
        implementer_name.setCustomValidity("");
      } else if (this.implementer_name.length > 255) {
        implementer_name.setCustomValidity("Người tham gia khác không được quá 255 ký tự!");
      } else {
        implementer_name.setCustomValidity("");
      }

      let re_review_add = document.getElementById("re_review");
      if (this.$commonFuction.isEmptyObject(this.re_review) || this.$commonFuction.isEmpty(this.re_review)) {
        re_review_add.setCustomValidity("Người đánh giá lại không được để trống!");
      } else {
        re_review_add.setCustomValidity("");
      }
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    validateEmail() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.email);
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      // this.clearValidateAdd()
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }
      if(this.evaluation_form_danger.length == 0){
        this.$commonFuction.is_loading(false);
        alert("Vui lòng thêm mối nguy!")
        return;
      }

      var params = {
        name: this.name,
        company: this.company,
        areas: this.areas,
        department: this.department,
        work: this.work,
        expiration_date: this.expiration_date,
        approve: this.approve,
        review: this.review,
        implementer: this.implementer,
        participants: this.participants,
        re_review: this.re_review,
        implementer_name : this.implementer_name,
      }
      if(this.mode == 'add'){
        params.evaluation_form_danger = this.evaluation_form_danger
      }
      console.log("saveData", params);
      this.$emit("save", params);
    },
    clearAreas(){
      this.areas_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.areas = null
    },
    clearWork(){
      this.work_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.work = null
    },
    clearApprove(){
      this.approve_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.approve = null
    },
    clearReview(){
      this.review_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.review = null
    },
    clearImplementer(){
      this.implementer_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.implementer = null
    },
    clearParticipant(){
      this.participant_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.participants = []
    },
    clearRereview(){
      this.re_review_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.re_review = null
    },
    clearSituation(){
      this.situation_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.situation = null
      this.other_situation_name = ''
    },
    clearCategory(){
      this.category_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.category = null
    },
    clearDanger(){
      this.danger_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.danger = null
      this.other_danger_name = ''
    },
    clearEvaluationFormDanger(){
      this.evaluation_form_danger = []
      this.tinhhuong = []
      this.moinguy = []
    },
    clearDepartment(){
      this.department_obj ={
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.department = null
    },
    hearderTitle(){
      return this.hearder_title
    },
    goHistory(item){
      this.$router.push({ path: '/admin/list-danger/history', query: { company_id: this.company.id,efd_id:item.id} });
    },
    goEvaluate(item){
      console.log("tới trang đánh giá",item)
      this.$router.push({ path: '/admin/list-danger/evaluation/'+item.id, query: { company_id: this.company.id } });
    },
    getShowEvaluate(item){
      console.log("item==",item)
      if(this.mode == 'edit'){
        // console.log("this.checkshowEval",this.checkshowEval)
        return this.checkshowEval
      }
      return false
    },
    formatNumber(value,decimals=2){
      const digitsRE = /(\d{3})(?=\d)/g
      value = parseFloat(value)
      if (!isFinite(value) || (!value && value !== 0)) return ''
      decimals = decimals != null ? decimals : 2
      var stringified = Math.abs(value).toFixed(decimals)
      var _int = decimals
        ? stringified.slice(0, -1 - decimals)
        : stringified
      var i = _int.length % 3
      var head = i > 0
        ? (_int.slice(0, i) + (_int.length > 3 ? '.' : ''))
        : ''
      var _float = decimals
        ? stringified.slice(-1 - decimals)
        : ''
      var sign = value < 0 ? '-' : '';
      var text = sign + head +
        _int.slice(i).replace(digitsRE, '$1.') +
        _float
      return text
    },
    async ShowPopup(data,key){
      var id = data.id
      this.$commonFuction.is_loading(true);
      if(id){
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
          const headers = {
            "Authorization": "Bearer "+token,
          };
          var that = this;
          await ApiRepository.post("/_api/evaluation_form_danger/risk", {id: id, company_id: that.company.id}, {headers}).then(function (response) {
            var resp = response.data.data;
            var tmp = []
            var code = ""
            var total = null
            if(key=='rb'){
              for (let i = 0; i < resp.risk_assessment.length; i++) {
                let e = resp.risk_assessment[i];
                let name = ''
                if(e.criteria_json && e.criteria_json.level){
                  name = e.criteria_json.level.name ?? ''
                }
                tmp.push({
                  code : e.criteria_json?.code,
                  point : that.formatNumber(e.point,0),
                  name : name,
                })
              }
              code = data.code_rb
              total = that.formatNumber(data.point_rb,0)
            }else if(key=='ra'){
              for (let i = 0; i < resp.risk_assessment_ra.length; i++) {
                let e = resp.risk_assessment_ra[i];
                let name = ''
                if(e.criteria_json && e.criteria_json.level){
                  name = e.criteria_json.level.name ?? ''
                }
                tmp.push({
                  code : e.criteria_json?.code,
                  point : that.formatNumber(e.point,0),
                  name :name,
                })
              }
              code = data.code_ra
              total = that.formatNumber(data.point_ra,0)
            }else{
              for (let i = 0; i < resp.risk_assessment_re.length; i++) {
                let e = resp.risk_assessment_re[i];
                let name = ''
                if(e.criteria_json && e.criteria_json.level){
                  name = e.criteria_json.level.name ?? ''
                }
                tmp.push({
                  code : e.criteria_json?.code,
                  point : that.formatNumber(e.point,0),
                  name : name,
                })
              }
              code = data.code_re
              total = that.formatNumber(data.point_re,0)
            }
            
            that.data_popup = {
              list : tmp,
              point : total,
              code : code
            }
            that.showDetailDialog = true;
            that.$commonFuction.is_loading(false);
            // console.log("datadata=",that.data_popup)
          }).catch((err) => {
            that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
            })
          })
        }
      }
      this.$commonFuction.is_loading(false);
    },
    goPgaeControlMeasures(data){
      console.log(data)
      this.$router.push({ path: '/admin/control_measures', query: { company_id: this.company_id } });
    },
    async checkExsit(){
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        var object = {
          id : this.id_edit ?? null,
          company_id: this.company.id,
          category_id: this.category.id,
          situation: this.situation,
          danger : this.danger,
          other_danger_name:this.other_danger_name,
          other_situation_name:this.other_danger_name,
          evaluation_form_id : this.$route.params.id
        }
        var check = false
        await ApiRepository.post("/_api/evaluation_form_danger/check_exsit", object, {headers}).then((res) => {
          console.log("res.data.data",res.data.data)
          check = res.data.data.check_exsit
          
        }).catch((err) => {
            console.log(err);
        })
        return check
      }
    },
    async removeParticipants(index){
      this.participants.splice(index, 1);
    },
  }
}
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox {
  margin-right: 1rem !important;
}
.cus-number {
  font-weight: 700;
  color : #0086c4;
}
#tb_level {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#tb_level td, #customers th {
  border: 1px solid #ddd;
  padding: 8px;
}
#tb_level th {
  border: 1px solid #ddd;
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  padding-left: 5px;
}
.cus-r {
  width: auto;
}
.dialog-min {
  min-width : 450px
}
.p-button-cancel{
  background: #FFFAF0;
  border: 1px solid #d0dde7;
  color : #000000
}
.cus-tags{
  border-radius: 10px;
  padding: 8px;
  margin-right: 8px;
  background-color:#F2F3F7;
}
.cs-tag {
  padding: 10px 12px 10px 0px;
  font-weight: normal;
}
.cs-icon {
  color : #666666;
  padding-right: 4px;
  cursor: pointer;
}
</style>
